import { ProjectEventType } from "@domain/project/project-event";
import { Exclude, Expose } from "class-transformer";
import { IsArray, IsOptional, IsString, IsUUID } from "class-validator";
import { v4 as uuidv4 } from "uuid";

interface ProjectImageOwner {
  publishUpdate(type: ProjectEventType, subject: unknown): void;
}

export class ProjectImageMetadata {
  @Exclude()
  private project?: ProjectImageOwner;

  @IsString()
  @Expose({ name: "name" })
  private _name: string;

  @IsUUID()
  public readonly id: string;

  public readonly addDate: Date;

  @IsOptional()
  @IsString()
  public description?: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  public tags?: string[];

  constructor(id: string, name: string, addDate: Date, description?: string, tags?: string[]) {
    this._name = name;
    this.id = id;
    this.addDate = addDate;
    this.description = description;
    this.tags = tags;
  }

  init(project: ProjectImageOwner) {
    this.project = project;
  }

  get name(): string {
    return this._name;
  }

  set name(name: string) {
    if (this._name === name) return;
    this._name = name;
    this.project?.publishUpdate(ProjectEventType.IMAGE_UPDATED, this);
  }

  static create(name: string, description?: string, tags?: string[]): ProjectImageMetadata {
    return new ProjectImageMetadata(uuidv4(), name, new Date(), description, tags);
  }
}
